import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import ArmyUnitInfo from "./ArmyUnitInfo";
import { ArmyUnit, General } from "../../../../lib/types";
import {
  openTooltip,
} from "../../../../store/actions";

import { armyUnits } from "../../../../assets/images/army";
import { systemClass } from "../../../../lib/enums";
import ArmyUnitAttributeLine from "./ArmyUnitAttributeLine";
import { getGeneralSkillLevel } from "../../../../lib/commonFunctions";
import { isTouchScreen } from "../../../../lib/elementUtilities";

interface IProps {
  unitType: string;
  unit: ArmyUnit;
  picture: string;
  soldierGeneral?: General;
  recruit: (
    amount: number,
    id?: number
  ) => void;
  release: (
    amount: number,
    id?: number
  ) => void;
}

const ArmyUnitPerson = ({
  unitType,
  unit,
  picture,
  recruit,
  release,
  soldierGeneral
}: IProps) => {
  const iconAvailableRef = useRef();
  const iconFiveAvailableRef = useRef(null);
  const fightingEngines = soldierGeneral && unitType === "s_engines" && getGeneralSkillLevel(soldierGeneral, 10);
  const dispatch = useDispatch();
  console.log(unit);
  return (
    <div className={`person ${systemClass.MatchHeight}`}>
      {
        unitType !== "s_engines"
          ? <ArmyUnitInfo
            unit={unit}
            picture={picture}
          />
          : <>
            <h3 className="name">{unit.name}</h3>
            <img src={armyUnits[`army${picture}`]} width={"126"} height={"126"} alt=""/>
            {!!fightingEngines && <ArmyUnitAttributeLine
              attributes={[
                {
                  icon: "utok",
                  title: "Attack",
                  content: "attack power, ability to hit",
                  value: fightingEngines * 2
                },
                {
                  icon: "obrana",
                  title: "Defence",
                  content: "defense power, ability to block hits",
                  value: fightingEngines * 2
                }
              ]}
            />}
            <p className="white">
                +2 wall attack
            </p>
          </>
      }
      <p className="white" style={{ marginTop: "5px" }}>
        <em className="js-price-gold">{unit.gold}</em> <i
        className="icon-zlato gold icon-sm icon icon-standalone align-sub"/> +
        <em className="js-price-weapons">{unit.weapons}</em> <i
        className="icon icon-sm icon-zbrane icon-standalone align-sub"/>
        {unit.traits.includes("archer")
        && <>
          <br/>Archer
        </>}
        {unit.traits.includes("light_infantry")
        && <>
          <br/>Light infantry
        </>}
        {unit.traits.includes("heavy_infantry")
        && <>
          <br/>Heavy infantry
        </>}
        {unit.traits.includes("light_cavalry")
        && <>
          <br/>Light cavalry
        </>}
        {unit.traits.includes("heavy_cavalry")
        && <>
          <br/>Heavy cavalry
        </>}
        {unit.traits.includes("shielded")
        && <>
          <br/>Shielded
        </>}
        {unit.traits.includes("skirmisher")
        && <>
          <br/>Skirmisher
        </>}
      </p>
      <div className="row">
        <div className={`col-md-5 col-xs-4 text-right no-padding-left ${unit.number ? "positive" : ""}`}>
          1
          <a
            className={`icon-minus icon align-sub ${unit.number ? "positive" : "disabled"}`}
            onClick={() => !!unit.number && release(1)}
          />
        </div>
        <div className="col-md-2 col-xs-4 text-center no-padding-right no-padding-left">
          {unit.number}
        </div>
        <div
          className={`col-md-5 col-xs-4 text-left no-padding-right ${Number.parseInt(unit.available, 10) === 1 ? "positive" : ""}`}>
          <a
            className={`icon-plus icon align-sub ${Number.parseInt(unit.available, 10) === 1 ? "positive" : "disabled"}`}
            onClick={() => Number.parseInt(unit.available, 10) === 1
              && recruit(1)}
          />
          1
          {Number.parseInt(unit.available, 10) !== 1
            ? <a href="#"
              // @ts-ignore
                 ref={iconAvailableRef}
                 onMouseEnter={() => !isTouchScreen() && dispatch(openTooltip({
                   static: true,
                   title: "Not available",
                   content: unit.available,
                   elementRef: iconAvailableRef
                 }))}
                 onMouseOver={() => !isTouchScreen() && dispatch(openTooltip({
                   static: true,
                   title: "Not available",
                   content: unit.available,
                   elementRef: iconAvailableRef
                 }))}
                 onClick={() => isTouchScreen() && dispatch(openTooltip({
                   static: true,
                   title: "Not available",
                   content: unit.available,
                   elementRef: iconAvailableRef
                 }))}
            >
              <i className="icon-circle red">!</i>
            </a> : <></>
          }
        </div>
      </div>
      <div className="row">
        <div className={`col-md-5 col-xs-4 text-right no-padding-left ${unit.number < 5 ? "" : "positive"}`}>
          5
          <a
            className={`icon-minus icon align-sub ${unit.number < 5 ? "disabled" : "positive"}`}
            onClick={() => unit.number >= 5 && release(5)}
          />
        </div>
        <div className="col-md-2 col-xs-4 text-center no-padding-right no-padding-left">&nbsp;</div>
        <div
          className={`col-md-5 col-xs-4 text-left no-padding-right ${Number.parseInt(unit.fiveAvailable, 10) === 1 ? "positive" : ""}`}>
          <a
            className={`icon-plus icon align-sub ${Number.parseInt(unit.fiveAvailable, 10) === 1 ? "positive" : "disabled"}`}
            onClick={() => Number.parseInt(unit.fiveAvailable, 10) === 1
              && recruit(5)}
          />
          5
          {Number.parseInt(unit.fiveAvailable, 10) !== 1
            ? <a
               ref={iconFiveAvailableRef}
               onMouseEnter={() => !isTouchScreen() && dispatch(openTooltip({
                 static: true,
                 title: "Not available",
                 content: unit.fiveAvailable,
                 elementRef: iconFiveAvailableRef
               }))}
               onMouseOver={() => !isTouchScreen() && dispatch(openTooltip({
                 static: true,
                 title: "Not available",
                 content: unit.fiveAvailable,
                 elementRef: iconFiveAvailableRef
               }))}
               onClick={() => isTouchScreen() && dispatch(openTooltip({
                 static: true,
                 title: "Not available",
                 content: unit.fiveAvailable,
                 elementRef: iconFiveAvailableRef
               }))}
            >
            <i className="icon-circle red">!</i>
          </a> : <></>
          }
        </div>
      </div>
    </div>
  )
}

export default ArmyUnitPerson;
